import type { AudioAnnotationRatingField } from '@/features/nectar/api/models'
import { clsx } from 'clsx'
import { FieldLabel } from '../FieldLabel'

type RatingFieldProps = {
  field: AudioAnnotationRatingField
  value: number | undefined
  onChange: (value: number) => void
}

const range = (min: number, max: number): number[] => {
  const out: number[] = []
  for (let i = min; i <= max; i++) out.push(i)
  return out
}

export const RatingField = ({ field, value, onChange }: RatingFieldProps) => (
  <div className="flex flex-col gap-3">
    <FieldLabel label={field.label} description={field.description} required={field.required} />
    <div className="flex flex-wrap gap-2">
      {range(field.min, field.max).map((n) => {
        const selected = value === n
        return (
          <button
            key={n}
            type="button"
            onClick={() => onChange(n)}
            className={clsx(
              'flex h-10 min-w-10 cursor-pointer items-center justify-center rounded-lg border border-solid px-3 font-semibold transition-colors',
              selected ? 'border-green bg-green/5 text-green' : 'text-gray-70 hover:border-gray-90 border-gray-100'
            )}
          >
            {n}
          </button>
        )
      })}
    </div>
  </div>
)
